/* StyledGenie theme behaviour: cart drawer, quick add, filters, wishlist, Genie looks, code copy. */
(() => {
  const S = window.sgSettings || { quickAdd: 'drawer', strings: {} };
  const T = S.strings || {};
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const SECTIONS = ['sg-cart-drawer', 'cart-icon-bubble'];

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  async function postJSON(path, body) {
    const res = await fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ ...body, sections: SECTIONS.join(','), sections_url: window.location.pathname }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.status) {
      const err = new Error(data.description || data.message || T.error || 'Error');
      err.data = data;
      throw err;
    }
    return data;
  }

  function publishCart(cartData) {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sg-drawer', cartData });
      }
    } catch (e) { /* Dawn pubsub not present */ }
  }

  /* ── toast ─────────────────────────────────────────── */
  let toastTimer;
  function toast(text) {
    const el = $('[data-sg-toast]');
    if (!el) return;
    $('[data-sg-toast-text]', el).textContent = text;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2600);
  }

  /* ── cart drawer ───────────────────────────────────── */
  class SgCartDrawer extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this.addEventListener('click', (e) => this.onClick(e));
      this.addEventListener('keydown', (e) => this.onKeydown(e));
      try {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.cartUpdate, (evt) => {
            if (evt && evt.source === 'external-refresh') this.refresh();
          });
        }
      } catch (e) { /* ignore */ }
    }

    get panel() { return $('.sg-drawer__panel', this); }

    // Dawn product-form / quick-add contract
    getSectionsToRender() { return SECTIONS.map((id) => ({ id })); }
    setActiveElement(el) { this.activeElement = el; }
    renderContents(parsed, opts = {}) {
      this.applySections(parsed && parsed.sections);
      const mode = opts.mode || S.quickAdd;
      if (mode === 'toast' && !opts.forceOpen) {
        const title = opts.title || (parsed && (parsed.product_title || (parsed.items && parsed.items[0] && parsed.items[0].product_title))) || '';
        toast(opts.toastText || (T.added || '[title] added').replace('[title]', title));
      } else {
        this.open(this.activeElement);
      }
    }

    applySections(sections) {
      if (!sections) return;
      const drawerHTML = sections['sg-cart-drawer'];
      if (drawerHTML) {
        const doc = new DOMParser().parseFromString(drawerHTML, 'text/html');
        const fresh = $('[data-sg-drawer-content]', doc);
        const current = $('[data-sg-drawer-content]', this);
        if (fresh && current) current.replaceWith(fresh);
      }
      const bubble = sections['cart-icon-bubble'];
      if (bubble != null) {
        const doc = new DOMParser().parseFromString(bubble, 'text/html');
        const txt = ($('.shopify-section', doc) || doc.body).textContent.trim();
        $$('#cart-icon-bubble').forEach((el) => { el.textContent = txt; });
      }
    }

    async refresh() {
      const res = await fetch(`${root}?sections=${SECTIONS.join(',')}`);
      if (res.ok) this.applySections(await res.json());
    }

    open(opener) {
      if (this.classList.contains('is-open')) return;
      this.opener = opener || document.activeElement;
      this.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(() => {
        const btn = $('[data-sg-close].sg-btn', this);
        (btn || this.panel).focus({ preventScroll: true });
      });
    }

    close() {
      this.classList.remove('is-open');
      document.body.style.overflow = '';
      if (this.opener && this.opener.focus) this.opener.focus({ preventScroll: true });
    }

    onKeydown(e) {
      if (e.key === 'Escape') { e.preventDefault(); this.close(); return; }
      if (e.key !== 'Tab') return;
      const focusables = $$('a[href], button:not([disabled]):not([tabindex="-1"]), input, [tabindex="0"]', this.panel)
        .filter((el) => el.offsetParent !== null);
      if (!focusables.length) return;
      const first = focusables[0], last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    showError(msg) {
      const el = $('[data-sg-error]', this);
      if (!el) return;
      el.textContent = msg;
      el.hidden = !msg;
    }

    async onClick(e) {
      if (e.target.closest('[data-sg-close]')) { this.close(); return; }
      const line = e.target.closest('[data-sg-line]');
      if (!line) return;
      const qtyBtn = e.target.closest('[data-sg-qty]');
      const swapBtn = e.target.closest('[data-sg-swap]');
      if (!qtyBtn && !swapBtn) return;

      const key = line.dataset.sgLine;
      const qty = parseInt(line.dataset.qty, 10) || 1;
      line.classList.add('is-busy');
      this.showError('');
      try {
        let data;
        if (qtyBtn) {
          data = await postJSON('cart/change.js', { id: key, quantity: parseInt(qtyBtn.dataset.sgQty, 10) });
        } else {
          // Swap size: drop this line and add the chosen variant (merging with an existing line of it).
          const newId = swapBtn.dataset.sgSwap;
          const existing = $$('[data-sg-line]', this).find((l) => l !== line && l.dataset.variant === newId);
          const updates = { [key]: 0 };
          if (existing) updates[existing.dataset.sgLine] = (parseInt(existing.dataset.qty, 10) || 0) + qty;
          else updates[newId] = qty;
          data = await postJSON('cart/update.js', { updates });
        }
        this.applySections(data.sections);
        publishCart(data);
        const focusTarget = $('.sg-drawer__body [data-sg-line] button', this) || $('[data-sg-close].sg-btn', this);
        if (focusTarget && !this.contains(document.activeElement)) focusTarget.focus({ preventScroll: true });
      } catch (err) {
        line.classList.remove('is-busy');
        this.showError(err.message);
      }
    }
  }
  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', SgCartDrawer);

  const drawer = () => document.querySelector('cart-drawer');

  /* ── add to bag ────────────────────────────────────── */
  async function addItems(items, btn, opts) {
    const d = drawer();
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true'); }
    try {
      const data = await postJSON('cart/add.js', { items });
      if (!d || S.cartType === 'page') { window.location.href = S.cartUrl || '/cart'; return; }
      d.setActiveElement(btn);
      d.renderContents(data, opts);
      publishCart(data);
    } catch (err) {
      if (d) { d.showError(err.message); d.open(btn); } else alert(err.message); // eslint-disable-line no-alert
    } finally {
      if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); }
    }
  }

  document.addEventListener('click', (e) => {
    const add = e.target.closest('[data-sg-add]');
    if (add) {
      e.preventDefault();
      addItems([{ id: Number(add.dataset.sgAdd), quantity: 1 }], add, { title: add.dataset.title });
      return;
    }
    const look = e.target.closest('[data-sg-add-look]');
    if (look) {
      e.preventDefault();
      const ids = look.dataset.sgAddLook.split(',').filter(Boolean);
      addItems(ids.map((id) => ({ id: Number(id), quantity: 1 })), look, {
        toastText: (T.lookAdded || 'Look added — [count] pieces').replace('[count]', ids.length),
      });
      return;
    }
    const openCart = e.target.closest('[data-sg-open-cart]');
    if (openCart && drawer() && S.cartType !== 'page') {
      e.preventDefault();
      $('[data-sg-toast]')?.classList.remove('is-visible');
      drawer().open(openCart);
      return;
    }
    const copy = e.target.closest('[data-sg-copy]');
    if (copy) {
      const code = copy.dataset.sgCopy;
      const done = () => {
        copy.textContent = T.copied || 'COPIED';
        clearTimeout(copy._t);
        copy._t = setTimeout(() => { copy.textContent = code; }, 1600);
      };
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done);
      else done();
      return;
    }
    const filter = e.target.closest('[data-sg-filter]');
    if (filter) { applyFilter(filter); return; }
    const wish = e.target.closest('[data-sg-wish]');
    if (wish) { toggleWish(wish); return; }
    const tab = e.target.closest('[data-sg-look-tab]');
    if (tab) { selectLook(tab); return; }
    // close the mobile menu after following an in-page link
    const menuLink = e.target.closest('[data-sg-menu] a');
    if (menuLink) menuLink.closest('details').removeAttribute('open');
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const menu = $('[data-sg-menu][open]');
      if (menu) { menu.removeAttribute('open'); $('summary', menu).focus(); }
    }
    const tab = e.target.closest && e.target.closest('[data-sg-look-tab]');
    if (tab && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
      const tabs = $$('[data-sg-look-tab]', tab.parentElement);
      const i = tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
      const next = tabs[(i + tabs.length) % tabs.length];
      selectLook(next);
      next.focus();
    }
  });

  /* ── New in filters ────────────────────────────────── */
  function applyFilter(btn) {
    const scope = btn.closest('[data-sg-filter-scope]');
    if (!scope) return;
    const key = btn.dataset.sgFilter;
    $$('[data-sg-filter]', scope).forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
    const groups = $$('[data-sg-group]', scope);
    const own = groups.find((g) => g.dataset.sgGroup === key);
    let n = 0;
    groups.forEach((g) => { g.hidden = g !== (own || groups[0]); });
    const active = own || groups[0];
    $$('[data-sg-card]', active).forEach((card) => {
      // plain labels (no own grid) filter the main grid by type/tag/collection keys
      const keys = card.dataset.keys || '';
      const show = !!own || !key || key.split('|').some((k) => keys.includes(` ${k} `));
      card.hidden = !show;
      if (show) n += 1;
    });
    const count = $('[data-sg-count]', scope);
    if (count && scope.dataset.countTemplate) count.textContent = scope.dataset.countTemplate.replace('[count]', n);
    const empty = $('[data-sg-empty]', scope);
    if (empty) empty.hidden = n > 0;
    paintWish();
  }

  /* ── wishlist (per browser) ────────────────────────── */
  const WISH_KEY = 'sg-wishlist';
  function readWish() { try { return JSON.parse(localStorage.getItem(WISH_KEY)) || []; } catch (e) { return []; } }
  function writeWish(list) { try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) { /* storage blocked */ } }
  function paintWish() {
    const list = readWish();
    $$('[data-sg-wish]').forEach((b) => b.setAttribute('aria-pressed', String(list.includes(b.dataset.sgWish))));
  }
  function toggleWish(btn) {
    const id = btn.dataset.sgWish;
    let list = readWish();
    list = list.includes(id) ? list.filter((x) => x !== id) : [...list, id];
    writeWish(list);
    $$(`[data-sg-wish="${id}"]`).forEach((b) => b.setAttribute('aria-pressed', String(list.includes(id))));
  }

  /* ── Genie looks ───────────────────────────────────── */
  function selectLook(tab) {
    const tabs = $$('[data-sg-look-tab]', tab.parentElement);
    tabs.forEach((t) => {
      const on = t === tab;
      t.setAttribute('aria-selected', String(on));
      t.tabIndex = on ? 0 : -1;
      const panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
  }

  /* ── header dropdowns ──────────────────────────────── */
  function setDD(item, open) {
    const btn = $('.sg-nav__caret', item);
    const panel = $('.sg-dd', item);
    if (!btn || !panel) return;
    if (open) $$('[data-sg-dd].is-open').forEach((o) => o !== item && setDD(o, false));
    item.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', String(open));
    panel.hidden = !open;
  }
  function initDropdowns() {
    $$('[data-sg-dd]').forEach((item) => {
      if (item._sgDD) return;
      item._sgDD = true;
      let t;
      const hoverable = window.matchMedia('(hover: hover)').matches;
      if (hoverable) {
        item.addEventListener('mouseenter', () => { clearTimeout(t); setDD(item, true); });
        item.addEventListener('mouseleave', () => { t = setTimeout(() => setDD(item, false), 180); });
      }
      $('.sg-nav__caret', item).addEventListener('click', () => setDD(item, !item.classList.contains('is-open')));
      item.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && item.classList.contains('is-open')) { setDD(item, false); $('.sg-nav__caret', item).focus(); }
      });
      item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) setDD(item, false); });
    });
  }
  initDropdowns();
  document.addEventListener('shopify:section:load', initDropdowns);

  /* ── testimonial carousel ─────────────────────────── */
  function initCarousels() {
    $$('[data-sg-carousel]').forEach((root) => {
      if (root._sgCar) return;
      root._sgCar = true;
      const track = $('[data-sg-car-track]', root);
      if (!track) return;
      const cards = $$(':scope > li', track);
      const dots = $$('[data-sg-car-dot]', root);
      const current = () => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      const goTo = (i) => {
        const n = (i + cards.length) % cards.length;
        track.scrollTo({ left: n * (cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0)), behavior: 'smooth' });
      };
      const paint = () => {
        const i = current();
        dots.forEach((d, j) => { if (j === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
        cards.forEach((c, j) => c.setAttribute('aria-hidden', String(j !== i)));
      };
      let raf; track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(paint); });
      paint();
      $('[data-sg-car-prev]', root)?.addEventListener('click', () => goTo(current() - 1));
      $('[data-sg-car-next]', root)?.addEventListener('click', () => goTo(current() + 1));
      dots.forEach((d) => d.addEventListener('click', () => goTo(parseInt(d.dataset.sgCarDot, 10))));
      track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current() + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current() - 1); }
      });
      const secs = parseInt(root.dataset.autoplay, 10);
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const pauseBtn = $('[data-sg-car-pause]', root);
      if (!secs || reduced || cards.length < 2) { pauseBtn?.remove(); return; }
      let userPaused = false, hover = false;
      setInterval(() => { if (!userPaused && !hover && !document.hidden) goTo(current() + 1); }, secs * 1000);
      root.addEventListener('mouseenter', () => { hover = true; });
      root.addEventListener('mouseleave', () => { hover = false; });
      root.addEventListener('focusin', () => { hover = true; });
      root.addEventListener('focusout', (e) => { if (!root.contains(e.relatedTarget)) hover = false; });
      const setPaused = (v) => {
        userPaused = v;
        pauseBtn?.setAttribute('aria-pressed', String(v));
        pauseBtn?.setAttribute('aria-label', v ? (window.accessibilityStrings?.playSlideshow || 'Play') : (window.accessibilityStrings?.pauseSlideshow || 'Pause'));
      };
      track.addEventListener('pointerdown', () => setPaused(true));
      pauseBtn?.addEventListener('click', () => setPaused(!userPaused));
    });
  }
  initCarousels();
  document.addEventListener('shopify:section:load', initCarousels);

  /* ── AI chat: open / close ─────────────────────────── */
  function initChatToggle() {
    const root = document.getElementById('styledgenie-chat-root');
    const bubble = $('[data-sg-chat-toggle]');
    if (!root || !bubble || bubble._sgBound) return;
    bubble._sgBound = true;
    const panel = () => root.querySelector('.styledgenie-launcher');
    const addClose = () => {
      const p = panel();
      if (!p || p.querySelector('.sg-chat-close')) return;
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'sg-chat-close';
      close.setAttribute('aria-label', 'Close chat');
      close.innerHTML = '<svg aria-hidden="true" width="16" height="16" viewBox="0 0 256 256" fill="none" stroke="currentColor" stroke-width="20" stroke-linecap="round"><line x1="200" y1="56" x2="56" y2="200"/><line x1="200" y1="200" x2="56" y2="56"/></svg>';
      close.addEventListener('click', () => setOpen(false));
      p.appendChild(close);
      p.setAttribute('role', 'dialog');
      p.setAttribute('aria-label', 'StyledGenie AI assistant');
    };
    const setOpen = (open) => {
      root.classList.toggle('is-closed', !open);
      bubble.setAttribute('aria-expanded', String(open));
      if (open) {
        addClose();
        const input = root.querySelector('#styledgenie-input');
        (input || panel())?.focus({ preventScroll: true });
      } else {
        bubble.focus({ preventScroll: true });
      }
    };
    bubble.addEventListener('click', () => setOpen(true));
    root.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !root.classList.contains('is-closed')) { e.stopPropagation(); setOpen(false); } });
    new MutationObserver(addClose).observe(root, { childList: true });
    addClose();
  }
  initChatToggle();
  document.addEventListener('DOMContentLoaded', initChatToggle);

  /* ── cookie settings link (Shopify privacy banner) ── */
  function initCookieLink() {
    const btn = $('[data-sg-cookie-settings]');
    if (!btn) return;
    const api = () => window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function';
    const show = () => { if (api()) btn.hidden = false; };
    show(); setTimeout(show, 1500); setTimeout(show, 4000);
    btn.addEventListener('click', () => { if (api()) window.privacyBanner.showPreferences(); });
  }
  initCookieLink();

  paintWish();
  document.addEventListener('shopify:section:load', paintWish);
  document.addEventListener('shopify:block:select', (e) => {
    const panel = e.target.closest && e.target.closest('.sg-look');
    if (panel) {
      const tab = document.querySelector(`[aria-controls="${panel.id}"]`);
      if (tab) selectLook(tab);
    }
  });

  /* ── Product gallery: previous / next arrows on the main image (desktop) ── */
  function initGalleryArrows() {
    document.querySelectorAll('media-gallery').forEach((gallery) => {
      if (gallery._sgArrows) return;
      const viewer = gallery.querySelector('slider-component[id^="GalleryViewer"]');
      const thumbs = () => [...gallery.querySelectorAll('.thumbnail-list__item .thumbnail')].filter((b) => getComputedStyle(b.closest('li')).display !== 'none');
      if (!viewer || thumbs().length < 2) return;
      gallery._sgArrows = true;
      const wrap = document.createElement('div');
      wrap.className = 'sg-gallery-nav';
      const mk = (dir, label) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'sg-gallery-nav__btn sg-gallery-nav__btn--' + dir;
        b.setAttribute('aria-label', label);
        b.innerHTML = '<svg aria-hidden="true" focusable="false" width="18" height="18" viewBox="0 0 256 256" fill="none" stroke="currentColor" stroke-width="20" stroke-linecap="round" stroke-linejoin="round"><polyline points="' + (dir === 'prev' ? '160,208 80,128 160,48' : '96,48 176,128 96,208') + '"/></svg>';
        return b;
      };
      const prev = mk('prev', window.Shopify && Shopify.locale === 'de' ? 'Vorheriges Bild' : 'Previous image');
      const next = mk('next', window.Shopify && Shopify.locale === 'de' ? 'Nächstes Bild' : 'Next image');
      const counter = document.createElement('span');
      counter.className = 'sg-gallery-nav__count';
      counter.setAttribute('aria-live', 'polite');
      wrap.append(prev, counter, next);
      viewer.appendChild(wrap);
      const current = () => { const list = thumbs(); return Math.max(0, list.findIndex((b) => b.getAttribute('aria-current') === 'true')); };
      const paint = () => { const list = thumbs(); counter.textContent = (current() + 1) + ' / ' + list.length; };
      const go = (step) => {
        const list = thumbs();
        const target = list[(current() + step + list.length) % list.length];
        if (target) { target.click(); requestAnimationFrame(paint); }
      };
      prev.addEventListener('click', () => go(-1));
      next.addEventListener('click', () => go(1));
      viewer.addEventListener('keydown', (e) => {
        if (e.target.closest('input, textarea, select')) return;
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      });
      gallery.addEventListener('click', (e) => { if (e.target.closest('.thumbnail')) requestAnimationFrame(paint); });
      paint();
    });
  }
  initGalleryArrows();
  document.addEventListener('DOMContentLoaded', initGalleryArrows);
  document.addEventListener('shopify:section:load', initGalleryArrows);
})();
